// ##### 25-02-05 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useMessages } from '../../../../helpers/messages';
// ##### 25-05-21 Komarov
import LocalizationNavLink from '../../../Library/Localization/LocalizationNavLink';
import Cooperation from './Cooperation';
import Requests from './Requests';

// ##### Komarov 2025-07-14
const DesktopMenuTextItems = ({
  sitepage_type,
  isWhiteLabelSet,
  companyCipher,
}) => {
  const pagesFromLocalStorageArray = Object.values(useMessages()).filter(
    page =>
      parseInt(sitepage_type.sitepage_type_id) ===
      parseInt(page.sitepage_type_id) &&
      parseInt(sitepage_type.sitepage_type_id) !== 7 &&
      // ##### Komarov 2025-07-26
      parseInt(page.id) !== 198 &&
      parseInt(page.id) !== 336
  );

  // ##### 24-06-21 Komarov
  const cooperation = pagesFromLocalStorageArray.find(
    page => page.name === 'Cooperation'
  );
  // ##### 24-08-07 Komarov
  const requests = pagesFromLocalStorageArray.find(
    page => page.name === 'Requests'
  );

  return pagesFromLocalStorageArray.length > 0 ? (
    <>
      {pagesFromLocalStorageArray
        .filter(
          page =>
            ![
              'Clients',
              'Suppliers',
              'Group Request',
              'Cooperation',
              'Requests',
            ].includes(page.name)
        )
        .map(page => {
          return (
            // ##### 25-04-21 Komarov
            <LocalizationNavLink
              to={
                (isWhiteLabelSet &&
                  `/ref${companyCipher}/sitepages/?name=${page.name}&spid=${page.id}`) ||
                `/sitepages/?name=${page.name}&spid=${page.id}`
              }
              key={uniqueId()}
            >
              {/* ##### 26-06-30 Komarov */}
              {parse(page.title?.[0]?.text ?? '')}
            </LocalizationNavLink>
          );
        })}
      <Cooperation
        pages={pagesFromLocalStorageArray.filter(page =>
          ['Clients', 'Suppliers'].includes(page.name)
        )}
        // ##### 26-06-30 Komarov
        title={cooperation?.title?.[0]?.text ?? ''}
        isWhiteLabelSet={isWhiteLabelSet}
        companyCipher={companyCipher}
      />
      {/* ##### 24-08-07 Komarov */}
      <Requests
        pages={pagesFromLocalStorageArray.filter(page =>
          ['Group Request'].includes(page.name)
        )}
        // ##### 26-06-30 Komarov
        title={requests?.title?.[0]?.text ?? ''}
        isWhiteLabelSet={isWhiteLabelSet}
        companyCipher={companyCipher}
      />
      {/* <LocalizationNavLink 
        to={
          (isWhiteLabelSet &&
            `/ref${companyCipher}/sitepages/?name=${cooperation.name}&spid=${cooperation.id}`) ||
          `/sitepages/?name=${cooperation.name}&spid=${cooperation.id}`
        }
        key={uniqueId()}
      >
        {parse(cooperation.title)}
      </LocalizationNavLink> */}
    </>
  ) : (
    React.Fragment
  );
};

export default DesktopMenuTextItems;
